import {api, commonApiWrapper} from "@/services/common-api";
import {IPaymentSuccessData} from "@/app/dashboard/models/PaymentSuccess";

export const getPaymentSuccessData = async (paymentIntent: string, paymentRecordId: string) => commonApiWrapper<IPaymentSuccessData>(api.get('payments/details', {params: {paymentIntent, paymentRecordId}}));